import React, { useEffect, useState } from 'react'
import './index.scss'
import clsx from 'clsx'
import FieldErrorSection from '@Components/Fields/FieldErrorSection'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import { stringEscapeNewlines } from '@App/helpers/string-escape-newlines'

interface InputTextProps {
    mainColor: boolean
    id: string
    label: string
    assistiveText?: string
    onChange: (value: string, id: string, label: string) => void
    disabled?: boolean
    value?: string | null
    errorMessage?: string
    password?: boolean
    autoComplete?: 'on' | 'off'
    helperTitle?: string
    helperTitleText?: string
    helperType?: '?' | 'i'
    isDuration?: boolean
    maxLength?: number
    isClear?: boolean
    required?: boolean
    textareaType?: boolean
    autoFocused?: boolean
    isEscapeNewlines?: boolean
}

const InputText = ({
    mainColor,
    disabled,
    id,
    label,
    assistiveText,
    onChange,
    value,
    errorMessage,
    password,
    autoComplete = 'off',
    helperTitle,
    helperTitleText,
    maxLength,
    required,
    textareaType,
    autoFocused,
    isEscapeNewlines,
    helperType,
}: InputTextProps) => {
    const [inputValue, setInputValue] = useState<string | null>(value || null)
    const [activeInputState, setActiveInputState] = useState(false)

    const onFocusInput = () => setActiveInputState(true)

    const onBlurInput = () => setActiveInputState(false)

    const handleChange = (event: any) => {
        const newValue = event.target.value
        setInputValue(newValue)
        if (newValue !== null) {
            onChange(newValue, id, label)
        }
    }

    useEffect(() => {
        setInputValue(value ? value : '')
    }, [value])

    const classNames = clsx(
        textareaType ? 'textarea-component' : 'input-text-component',
        mainColor ? 'main-color-set' : 'second-color-set',
        disabled && 'disabled',
        activeInputState && 'focused',
        inputValue && 'filled',
        errorMessage && 'error'
    )

    const Field = textareaType ? 'textarea' : 'input'

    return (
        <div className={classNames} data-testid={'input-text-component-' + id}>
            <label htmlFor={id}>
                <>
                    {label}{' '}
                    {helperTitleText && (helperTitle || helperType) && (
                        <CustomToolTip title={helperTitle} info={helperTitleText} type={helperType} inverse />
                    )}
                </>
            </label>

            <Field
                type={!textareaType && password ? 'password' : 'text'}
                id={id}
                onBlur={!disabled ? onBlurInput : () => {}}
                onFocus={!disabled ? onFocusInput : () => {}}
                onChange={!disabled ? handleChange : () => {}}
                value={inputValue ? (isEscapeNewlines ? stringEscapeNewlines(inputValue) : inputValue) : ''}
                autoComplete={autoComplete}
                maxLength={maxLength}
                autoFocus={autoFocused}
            />
            <FieldErrorSection errorMessage={errorMessage} assistiveText={assistiveText} required={required} />
        </div>
    )
}

export default InputText
